import CheckboxReduxWrapper from './CheckboxReduxWrapper';

export default CheckboxReduxWrapper;
